var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.666 20.5C5.136 20.5 3.5 18.767 3.5 16.084V7.916C3.5 5.233 5.136 3.5 7.666 3.5H16.335C18.865 3.5 20.5 5.233 20.5 7.916V16.084C20.5 18.767 18.865 20.5 16.335 20.5H7.666ZM16.335 2H7.666C4.277 2 2 4.378 2 7.916V16.084C2 19.622 4.277 22 7.666 22H16.335C19.724 22 22 19.622 22 16.084V7.916C22 4.378 19.724 2 16.335 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.16418C11.586 7.16418 11.25 7.50018 11.25 7.91418V16.0862C11.25 16.5002 11.586 16.8362 12 16.8362C12.414 16.8362 12.75 16.5002 12.75 16.0862V7.91418C12.75 7.50018 12.414 7.16418 12 7.16418Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 7.16298C11.8012 7.16298 11.6092 7.24198 11.4692 7.38398L7.72119 11.148C7.42819 11.442 7.43019 11.917 7.72319 12.209C8.01719 12.5 8.49119 12.502 8.78319 12.207L12.0002 8.97598L15.2172 12.207C15.5102 12.502 15.9842 12.5 16.2772 12.209C16.5702 11.917 16.5722 11.442 16.2792 11.148L12.5312 7.38398C12.3912 7.24198 12.1992 7.16298 12.0002 7.16298Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpS);
export default __webpack_public_path__ + "static/media/ArrowUpS.6e696ab499eb688d8b91c7966d42b7cd.svg";
export { ForwardRef as ReactComponent };